var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomOutWhiteBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157145",
    "data-name": "Rectangle 157145",
    width: 38,
    height: 38,
    rx: 8,
    transform: "translate(38) rotate(90)",
    fill: "#fff",
    stroke: "#e8eaee",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157085",
    "data-name": "Rectangle 157085",
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(-1.284 -1.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75068",
    "data-name": "Group 75068",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73711",
    "data-name": "Path 73711",
    d: "M17.568,17h-4.64a.928.928,0,1,0,0,1.856h4.64a.928.928,0,1,0,0-1.856Z",
    transform: "translate(-8.288 -10.968)",
    fill: "#2e4d7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73712",
    "data-name": "Path 73712",
    d: "M22.283,20.983l-5.8-5.8a6.983,6.983,0,1,0-1.3,1.3l5.8,5.8a.919.919,0,1,0,1.3-1.3ZM10.96,16.065a5.1,5.1,0,1,1,5.1-5.1A5.1,5.1,0,0,1,10.96,16.065Z",
    transform: "translate(-4 -4)",
    fill: "#2e4d7b"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutWhiteBackground);
export default __webpack_public_path__ + "static/media/ZoomOutWhiteBackground.8eca1c456f75e1cca0f59138273fc867.svg";
export { ForwardRef as ReactComponent };